import { AgentModal, useAgentRow } from "@zapier/agents";
import { HydratedAgent } from "@zapier/client";
import { useTranslations } from "@zapier/i18n";
import { FolderModal } from "@zapier/shared";
import AssetRow from "./AssetRow";

interface Props {
  allowSelection?: boolean;
  agent: HydratedAgent;
  folderId?: string;
  showLastRun?: boolean;
  showLocationColumn?: boolean;
  setCurrentAgent: (agent: HydratedAgent | undefined) => void;
  setCurrentModal: (modal: AgentModal | FolderModal | undefined) => void;
  onCopyToAnotherAccount?: (asset: HydratedAgent) => void;
}

export function AssetRowAgent({
  allowSelection,
  agent,
  folderId,
  showLastRun,
  showLocationColumn,
  setCurrentAgent,
  setCurrentModal,
  onCopyToAnotherAccount,
}: Props) {
  const tShared = useTranslations("fallbacks");
  const { menuItems, triggerPermissionsCheck } = useAgentRow({
    agent,
    setCurrentAgent,
    setCurrentModal,
    onCopyToAnotherAccount,
  });

  return (
    <AssetRow
      allowSelection={allowSelection}
      asset={agent}
      folderId={folderId}
      folderZapTableRow={true}
      isUntitled={agent?.name?.length === 0}
      menuItems={menuItems}
      onOpenMenu={triggerPermissionsCheck}
      showLastRun={showLastRun}
      showLocationColumn={showLocationColumn}
      title={agent.name || tShared("untitled-asset", { assetType: "Agent" })}
      updatedAt={new Date(agent.updatedAt ?? "")}
    />
  );
}
